import { FormElement } from './form-element.model';

export class FormElementTextDisplay extends FormElement {
  public constructor() {
    super();

    this.intialize();
  }

  public intialize = (): void => {
    this.Text = '';
    this.ElementTypeId = 7;
  };

  public Text: string;
}
